import React from 'react';
import { Tooltip } from 'react-tooltip';
import uuid from 'react-uuid';
import { Grid } from '@mui/material';
import styled from 'styled-components';
import { AccountData, OrderPageData } from '../../api';
import { getOrderPages } from '../../utils/AccountUtils';
import { getContrastColor } from './getContrastColor';
import { DEFAULT_ORDER_PAGE_COLOR } from '../theme/mbTokens';

export const StyledCircle = styled.div`
  width: 18px;
  height: 18px;
  border-radius: 3px;
`;

export const WorkshopCircle = ({
  account,
  orderPageId,
  withTooltip,
  language,
  customDetailAmoount,
}: {
  account: AccountData;
  orderPageId?: string;
  withTooltip?: boolean;
  language: 'he' | 'en';
  customDetailAmoount?: number;
}) => {
  if (!orderPageId) {
    return <StyledCircle style={{ backgroundColor: DEFAULT_ORDER_PAGE_COLOR }} />;
  }
  const orderPage = getOrderPages(account).find((x: OrderPageData) => x.id === orderPageId);
  const id = `tooltip-${orderPageId}-${uuid()}`;
  const backgroundColor = orderPageId
    ? getOrderPages(account).find((x: OrderPageData) => x.id === orderPageId)?.color || DEFAULT_ORDER_PAGE_COLOR
    : DEFAULT_ORDER_PAGE_COLOR;

  const textColor = getContrastColor(backgroundColor);
  return (
    <>
      <Tooltip
        place="bottom"
        content={withTooltip ? orderPage?.label[language] : ''}
        id={id}
        variant="light"
        border="1px solid black"
      />

      <StyledCircle style={{ backgroundColor, position: 'relative' }} data-tooltip-id={id}>
        <Grid
          container
          alignItems="center"
          justifyContent="center"
          sx={{
            color: textColor,
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            fontSize: '12px',
            fontWeight: 'bold',
          }}>
          {customDetailAmoount}
        </Grid>
      </StyledCircle>
    </>
  );
};
